import createIcon from '../../createIcon';

/**
 * @component @name PostAdd
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNSAxOS43Mkg0LjVWNy41SDExLjVWNS41SDQuNUMzLjQgNS41IDIuNSA2LjQgMi41IDcuNVYxOS41QzIuNSAyMC42IDMuNCAyMS41IDQuNSAyMS41SDE2LjVDMTcuNiAyMS41IDE4LjUgMjAuNiAxOC41IDE5LjVWMTIuNUgxNi41VjE5LjcyWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE4LjUgMi41SDE2LjVWNS41SDEzLjVDMTMuNTEgNS41MSAxMy41IDcuNSAxMy41IDcuNUgxNi41VjEwLjQ5QzE2LjUxIDEwLjUgMTguNSAxMC40OSAxOC41IDEwLjQ5VjcuNUgyMS41VjUuNUgxOC41VjIuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNC41IDkuNUg2LjVWMTEuNUgxNC41VjkuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik02LjUgMTIuNVYxNC41SDE0LjVWMTIuNUg2LjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTQuNSAxNS41SDYuNVYxNy41SDE0LjVWMTUuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PostAdd = createIcon('PostAdd', [
  [
    'path',
    {
      d: 'M16.5 19.72H4.5V7.5H11.5V5.5H4.5C3.4 5.5 2.5 6.4 2.5 7.5V19.5C2.5 20.6 3.4 21.5 4.5 21.5H16.5C17.6 21.5 18.5 20.6 18.5 19.5V12.5H16.5V19.72Z',
      key: '17n8tj',
    },
  ],
  [
    'path',
    {
      d: 'M18.5 2.5H16.5V5.5H13.5C13.51 5.51 13.5 7.5 13.5 7.5H16.5V10.49C16.51 10.5 18.5 10.49 18.5 10.49V7.5H21.5V5.5H18.5V2.5Z',
      key: 'twqjhe',
    },
  ],
  ['path', { d: 'M14.5 9.5H6.5V11.5H14.5V9.5Z', key: 'trbpd1' }],
  ['path', { d: 'M6.5 12.5V14.5H14.5V12.5H6.5Z', key: 'td4xkj' }],
  ['path', { d: 'M14.5 15.5H6.5V17.5H14.5V15.5Z', key: '1kn7fp' }],
]);

export default PostAdd;
